/* eslint-disable */
import BaseService from "../../BaseService";

const { http, axios, buildHeaders, buildEndpoint } = BaseService();

export function GetBienDongDi(postdata) {
  const data = { ...postdata };
  return http({
    url: "DanhSachBienDong/get-all-bien-dong-di-of-don-vi",
    method: "post",
    data,
  });
}
export function GetBienDongDen(postdata) {
  const data = { ...postdata };
  return http({
    url: "DanhSachBienDong/get-all-bien-dong-den-of-don-vi",
    method: "post",
    data,
  });
}
export function GetNghiViec(postdata) {
  const data = { ...postdata };
  return http({
    url: "DanhSachBienDong/get-all-nghi-viec-of-don-vi",
    method: "post",
    data,
  });
}

export function CanBoCongChucBienDongCreate(postdata) {
  const data = { ...postdata };
  return http({
    url: "DanhSachBienDong/Create",
    method: "post",
    data,
  });
}
export function CanBoCongChucBienDongUpdate(postdata) {
  const data = { ...postdata };
  return http({
    url: "DanhSachBienDong/Update",
    method: "post",
    data,
  });
}

export function CanBoCongChucBienDongAccept(postdata) {
  const data = { ...postdata };
  return http({
    url: "DanhSachBienDong/Accept",
    method: "post",
    data,
  });
}
export function CanBoCongChucBienDongRefuse(postdata) {
  const data = { ...postdata };
  return http({
    url: "DanhSachBienDong/Refuse",
    method: "post",
    data,
  });
}

export function CanBoCongChucBienDongDelete(postdata) {
  const data = { ...postdata };
  return http({
    url: "DanhSachBienDong/Delete",
    method: "post",
    data,
  });
}

////////////////////////////////////
